import citation from './citation';
import image from './image';
import highlight from './highlight';
import table from './table';

export default {
	citation,
	image,
	highlight,
	table
};
